import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { PatchSettingsRequest } from '@wf/shared'
import { api } from '../api/client'

export function useSettings() {
  return useQuery({ queryKey: ['settings'], queryFn: api.getSettings })
}

export function usePatchSettings() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: PatchSettingsRequest) => api.patchSettings(body),
    // Die Antwort ist der frische Settings-Stand → direkt in den Cache.
    onSuccess: (data) => qc.setQueryData(['settings'], data),
  })
}
